import api from '../api';

export const POLLS_MAKE_INVALIDATE = 'POLLS_MAKE_INVALIDATE';

export const POLLS_REQUEST = 'POLLS_REQUEST';
export const POLLS_SUCCESS = 'POLLS_SUCCESS';
export const POLLS_FAILURE = 'POLLS_FAILURE';

export const NEW_POLL_REQUEST = 'NEW_POLL_REQUEST';
export const NEW_POLL_SUCCESS = 'NEW_POLL_SUCCESS';
export const NEW_POLL_FAILURE = 'NEW_POLL_FAILURE';

export const pollsMakeInvalidate = () => ({
  type: POLLS_MAKE_INVALIDATE,
});


// Запрос опросов с сервера
export const pollsRequest = () => ({
  type: POLLS_REQUEST,
});

export const pollsSuccess = data => ({
  type: POLLS_SUCCESS,
  payload: data,
});

export const pollsFailure = errString => ({
  type: POLLS_FAILURE,
  payload: { err: errString },
});


// Новый опрос
export const newPollRequest = data => ({
  type: NEW_POLL_REQUEST,
  payload: data,
});

export const newPollSuccess = data => ({
  type: NEW_POLL_SUCCESS,
  payload: data,
});

export const newPollFailure = errString => ({
  type: NEW_POLL_FAILURE,
  payload: { err: errString },
});


/**
* Преобразование данных из api в state для голосований из GET /polls/list
*/
export const api2statePolls = (apiData) => {
  const keys = [];
  const data = {};
  let hasOwn = false;
  const itemConvert = (item) => {
    const { id } = item;
    keys.push(id);
    data[id] = {};
    data[id].title = item.title;
    data[id].endsAt = item.ends_at;
    data[id].status = item.status;
    data[id].isOwner = item.owner;
    if (!hasOwn) {
      hasOwn = item.owner;
    }
  };

  if (apiData.data.polls) {
    apiData.data.polls.forEach(itemConvert);
  } else if (apiData.data.poll) {
    itemConvert(apiData.data.poll);
    hasOwn = true;
  }

  return { keys, data, hasOwn };
};


/**
* Получение данных голосований для определенной школы (GET /polls/list)
*/
export const fetchPolls = schoolId => (
  async (dispatch) => {
    dispatch(pollsRequest());
    try {
      const response = await api('cabinet/polls/list', 'get', {
        params: { school_id: schoolId },
      });
      dispatch(pollsSuccess(api2statePolls(response)));
    } catch (error) {
      dispatch(pollsFailure('Не удалось получить данные голосований'));
    }
  }
);

/**
* Создание нового голосования (POST /polls/new)
*/
export const sendNewPoll = (pollData, cb) => (
  async (dispatch) => {
    dispatch(newPollRequest(pollData));
    try {
      const response = await api('cabinet/polls/new', 'post', { data: pollData });
      if (response.data.result === 'success') {
        dispatch(newPollSuccess(api2statePolls(response)));
        if (typeof cb === 'function') {
          cb(response.data.poll.id);
        }
      }
    } catch (error) {
      dispatch(newPollFailure('Не удалось создать новое голосование'));
    }
  }
);
